"use client";

import React, { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const tiers = [{
  id: "basic",
  name: "Senior Discount",
  description: "Honoring our Albany elders with specialized care.",
  priceSingle: "10% OFF",
  priceSub: "15% OFF",
  isPopular: false
}, {
  id: "premium",
  name: "Veteran Appreciation",
  description: "A salute to those who served our community.",
  priceSingle: "15% OFF",
  priceSub: "10% OFF",
  isPopular: true
}, {
  id: "luksus",
  name: "The 'Full Tune-Up'",
  description: "Comprehensive seasonal maintenance package.",
  priceSingle: "Call For Price",
  priceSub: "Call For Price",
  isPopular: false
}];
const tierFeatures = [{
  tierId: "basic",
  feature: "Valid for ages 65+"
}, {
  tierId: "basic",
  feature: "Free multi-point inspection"
}, {
  tierId: "basic",
  feature: "Priority weekday booking"
}, {
  tierId: "premium",
  feature: "Active & retired military"
}, {
  tierId: "premium",
  feature: "Free fluid top-offs"
}, {
  tierId: "premium",
  feature: "10% off all replacement parts"
}, {
  tierId: "premium",
  feature: "Complimentary shuttle service"
}, {
  tierId: "luksus",
  feature: "Oil change & filter swap"
}, {
  tierId: "luksus",
  feature: "Brake system calibration"
}, {
  tierId: "luksus",
  feature: "Tire rotation & balancing"
}, {
  tierId: "luksus",
  feature: "Battery health diagnostic"
}];
export default function ChooseTheRightPackage() {
  const [isSubscription, setIsSubscription] = useState(false);
  return <section data-section-id="221503" id="community-savings-specials" className="bg-background text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-primary/5 blur-[120px] rounded-full" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold mb-6 tracking-tight uppercase">
            Community Savings & Specials
          </h2>
          <p className="font-default text-lg text-muted-foreground mb-10">
            Dott's Garage has been a staple in Albany for over 100 years. We take pride in giving back to the neighbors who have trusted us for generations.
          </p>

          <div className="flex items-center justify-center gap-4">
            <span className={`font-default text-sm font-medium transition-colors ${!isSubscription ? "text-foreground" : "text-muted-foreground"}`}>
              Standard Rate
            </span>
            <Switch checked={isSubscription} onCheckedChange={setIsSubscription} aria-label="Skift mellem enkeltvask og abonnement" className="data-[state=checked]:bg-primary" />
            <span className={`font-default text-sm font-medium transition-colors flex items-center gap-2 ${isSubscription ? "text-foreground" : "text-muted-foreground"}`}>
              Member Rate
              <span className="inline-flex items-center rounded-full bg-primary/20 px-2 py-0.5 text-xs font-bold text-primary">
                SAVE MORE
              </span>
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 items-center max-w-6xl mx-auto">
          {tiers.map((tier, i) => {
          const features = tierFeatures.filter(f => f.tierId === tier.id);
          return <Card key={tier.id} data-index={i} className={`relative flex flex-col h-full transition-all duration-300 rounded-md bg-white text-primary shadow-xl ${tier.isPopular ? "border-primary border-[3px] shadow-2xl md:scale-105 z-10" : "border-border/40 hover:border-primary/50"}`}>
                {tier.isPopular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-20">
                    <Badge className="bg-primary text-white px-4 py-1 rounded-none text-xs font-bold tracking-widest uppercase shadow-lg border-none">
                      Most Requested
                    </Badge>
                  </div>}

                <CardHeader className="text-center pb-2">
                  <CardTitle className="font-default text-2xl mb-2 uppercase tracking-tight text-primary">
                    {tier.name}
                  </CardTitle>
                  <CardDescription className="font-default min-h-[40px] text-muted-foreground">
                    {tier.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow flex flex-col">
                  <div className="text-center mb-8">
                    <span className="font-default text-5xl font-bold text-primary transition-all duration-300">
                      {isSubscription ? tier.priceSub : tier.priceSingle}
                    </span>
                  </div>

                  <ul className="space-y-4 flex-grow">
                    {features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                        <Check className="size-5 text-primary shrink-0 mt-0.5" />
                        <span className="font-default text-sm text-foreground/90">
                          {feature.feature}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="pt-6">
                  <Button className={`w-full font-default font-bold text-base h-12 uppercase tracking-wider rounded-full transition-all hover:opacity-90 ${tier.isPopular ? "bg-primary text-white" : "bg-white text-primary border-2 border-primary hover:bg-primary/5"}`} asChild>
                    <Link to="/BookAppointmentPage">Claim Discount</Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}